// extracted by mini-css-extract-plugin
export default {"mainDiv":"DrawerContent_mainDiv__TwqLa","listText":"DrawerContent_listText__cltNT","textCadabams":"DrawerContent_textCadabams__-nIKC"};